import React from 'react';
import clsx from 'clsx';
import { NextFutureImage } from '../image/NextFutureImage';
import { Tooltip } from './Tooltip';

export const FeedCuratorTooltip = ({
  toolTipOffset,
  portal = false,
  noTooltip = false,
  size = 18,
}: {
  toolTipOffset?: number;
  /** If true, the tooltip will be rendered in a portal */
  portal?: boolean;
  noTooltip?: boolean;
  size?: number;
}) => {
  const verifiedCheck = (
    <div
      className={clsx(
        !noTooltip && 'md:[&_svg]:hover:rounded-full md:[&_svg]:hover:shadow-secondary ',
      )}
    >
      <NextFutureImage
        alt="Sound Curator"
        src="https://d16zqvkniqf1rn.cloudfront.net/sound-evangelist.png"
        width={size}
        height={size}
        sizes="20px"
        quality={80}
      />
    </div>
  );

  const content = (
    <Tooltip.StyledContent className="px-2" sideOffset={toolTipOffset}>
      Sound Curator
    </Tooltip.StyledContent>
  );
  return noTooltip ? (
    <div>{verifiedCheck}</div>
  ) : (
    <div>
      <div className="block md:!hidden">{verifiedCheck}</div>
      <div className="!hidden md:!block">
        <Tooltip openOnClick={false}>
          <Tooltip.Trigger asChild>{verifiedCheck}</Tooltip.Trigger>
          {portal ? <Tooltip.Portal>{content}</Tooltip.Portal> : content}
        </Tooltip>
      </div>
    </div>
  );
};
